import { formatAmount } from '@/src/utils/formatters'
import React from 'react'

interface PriceComponentProps {
  title?: string
  price: number
  lineThrough?: boolean
  currency?: string
}
export default function PriceComponent({ title, price, lineThrough, currency }: PriceComponentProps) {
  return (
    <>
      {title && <span>{title} - </span>}<span className={lineThrough ? 'line-through' : ''}> {formatAmount(price, currency ?? 'EUR')}</span>
    </>
  )
}
